import { render } from "./Opportunities.vue?vue&type=template&id=cb71204a"
import script from "./Opportunities.vue?vue&type=script&lang=js"
export * from "./Opportunities.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__